import {Directive, HostListener, Output, EventEmitter} from '@angular/core'

@Directive({
  selector: '[scrollEnd]',
  standalone: false,
})
export class ScrollEndDirective {
  @Output() nearEnd: EventEmitter<any>

  constructor() {}

  @HostListener('scroll', ['$event'])
  onScroll(event) {
    let tracker = event.target
    let limit = tracker.scrollHeight - tracker.clientHeight
    if (event.target.scrollTop === limit) {
      alert('end reached')
      // just emit a value
      this.nearEnd.emit(true)
    }
  }
}
